module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_other_label-538488428ac510d307a22a7fff62bb2a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/cat_other_label.png
 ** module id = 155
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/